import { render, staticRenderFns } from "./wsEmbedEditor.vue?vue&type=template&id=3b72f97b&"
import script from "./wsEmbedEditor.vue?vue&type=script&lang=js&"
export * from "./wsEmbedEditor.vue?vue&type=script&lang=js&"
import style0 from "./wsEmbedEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VExpandTransition,VIcon,VSheet,VTextField})
